import React, { useState, useEffect, useRef } from "react";
import "./style/tour.css";
import ExplourZoom from "./explourZoom";
import Floors from "../villacard/floors";
import { useFloors } from "../../api/zones/useFloors";

function Tour({ typeId, currentFloor, setCurrentFloor }) {
  const containerRef = useRef(null);
  const { floors, loading, error } = useFloors(typeId);

  const [zoomLevel, setZoomLevel] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [isPanning, setIsPanning] = useState(false);
  const [startPan, setStartPan] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 920);

  const floorsList = Array.isArray(floors?.data) ? floors.data : [];
  const isDataReady = floorsList.length > 0;
  const currentFloorData = isDataReady ? (floorsList.find((f) => f.name === currentFloor) || floorsList[0]) : null;
  const imageSource = currentFloorData ? currentFloorData.image : "";

  // الـ Effect المصلح
  useEffect(() => {
    if (loading) return; 

    const el = containerRef.current;
    if (!el) return;

    const onWheel = (e) => {
      e.preventDefault();
      const zoomSpeed = 0.001;
      setZoomLevel((prev) => {
        const newZoom = prev + e.deltaY * -zoomSpeed;
        return Math.min(Math.max(newZoom, 1), 4);
      });
    };

    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, [loading]); // ضروري جداً وجود loading هنا

  const handleMouseDown = (e) => {
    setIsPanning(true);
    setStartPan({ x: e.clientX - pan.x, y: e.clientY - pan.y });
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isPanning) return;
    const max = 200;
    setPan({
      x: Math.min(Math.max(e.clientX - startPan.x, -max), max),
      y: Math.min(Math.max(e.clientY - startPan.y, -max), max),
    });
  };

  const handleMouseUp = () => setIsPanning(false);

  const handleZoomIn = () => setZoomLevel((z) => Math.min(z + 0.2, 4));
  const handleZoomOut = () => setZoomLevel((z) => Math.max(z - 0.2, 1));
  const handleRestart = () => { setZoomLevel(1); setPan({ x: 0, y: 0 }); };

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 700);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  if (loading) return <div className="text-white p-5">Loading Floors...</div>;
  if (error) return <div className="text-danger p-5">Error loading data</div>;
  if (!isDataReady) return <div className="text-white p-5">No plans available.</div>;

  return (
    <div
      ref={containerRef}
      className="tour-container col-md-12 col-12"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      style={{ cursor: isPanning ? "grabbing" : "grab", overflow: 'hidden' }}
    >
      <div className="tour-image-container" style={{ transform: `translate(${pan.x}px, ${pan.y}px)` }}>
        {imageSource && (
          <img
            src={imageSource}
            alt="Tour"
            className="tour-image"
            style={{
              transform: `scale(${zoomLevel}) rotate(${isMobile ? "-90deg" : "0deg"})`,
              transition: isPanning ? "none" : "transform 0.3s ease",
            }}
            draggable={false}
          />
        )}
      </div>
{isMobile && (
  <Floors
    variant="tour"
    floorsData={floorsList}
    currentFloor={currentFloor} // مرري القيمة الحالية هنا
    onFloorSelect={(floorName) => setCurrentFloor(floorName)}
  />
)}
      {/* {isMobile && (
        <Floors
          variant="tour"
          floorsData={floorsList}
          onFloorSelect={(floorName) => setCurrentFloor(floorName)}
        />
      )} */}

      <ExplourZoom onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} onRestart={handleRestart} />
    </div>
  );
}

export default Tour;
// import React, { useState, useEffect, useRef } from "react";
// import "./style/tour.css";
// import ExplourZoom from "./explourZoom";
// import Floors from "../villacard/floors";

// function Tour({ currentFloor, setCurrentFloor }) {
//   const containerRef = useRef(null);

//   const [zoomLevel, setZoomLevel] = useState(1);
//   const [pan, setPan] = useState({ x: 0, y: 0 });
//   const [isPanning, setIsPanning] = useState(false);
//   const [startPan, setStartPan] = useState({ x: 0, y: 0 });
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 920);

//   const floorImages = {
//     Gf: require("../../assets/photo1.png"),
//     "1F": require("../../assets/photo3.png"),
//     RF: require("../../assets/77 1f.png"),
//   };

//   /* ================== WHEEL ZOOM (NO PAGE SCROLL) ================== */
//   useEffect(() => {
//     const el = containerRef.current;
//     if (!el) return;

//     const onWheel = (e) => {
//       e.preventDefault(); // 🔥 يمنع Scroll الصفحة

//       const zoomSpeed = 0.001;
//       setZoomLevel((prev) => {
//         const newZoom = prev + e.deltaY * -zoomSpeed;
//         return Math.min(Math.max(newZoom, 1), 4);
//       });
//     };

//     el.addEventListener("wheel", onWheel, { passive: false });

//     return () => el.removeEventListener("wheel", onWheel);
//   }, []);

//   /* ================== PAN ================== */
//   const handleMouseDown = (e) => {
//     setIsPanning(true);
//     setStartPan({
//       x: e.clientX - pan.x,
//       y: e.clientY - pan.y,
//     });
//     e.preventDefault();
//   };

//   const handleMouseMove = (e) => {
//     if (!isPanning) return;

//     const max = 200;
//     const newX = e.clientX - startPan.x;
//     const newY = e.clientY - startPan.y;

//     setPan({
//       x: Math.min(Math.max(newX, -max), max),
//       y: Math.min(Math.max(newY, -max), max),
//     });
//   };

//   const handleMouseUp = () => setIsPanning(false);

//   /* ================== CONTROLS ================== */
//   const handleZoomIn = () => setZoomLevel((z) => Math.min(z + 0.2, 4));

//   const handleZoomOut = () => setZoomLevel((z) => Math.max(z - 0.2, 1));

//   const handleRestart = () => {
//     setZoomLevel(1);
//     setPan({ x: 0, y: 0 });
//   };

//   useEffect(() => {
//     const resize = () => setIsMobile(window.innerWidth <= 920);
//     window.addEventListener("resize", resize);
//     return () => window.removeEventListener("resize", resize);
//   }, []);

//   return (
//     <div
//       ref={containerRef}
//       className="tour-container col-md-12 col-12"
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//     >
//       <div
//         className="tour-image-container"
//         style={{
//           transform: `translate(${pan.x}px, ${pan.y}px)`,
//         }}
//       >
//         <img
//           src={floorImages[currentFloor]}
//           alt="Tour"
//           className="tour-image"
//           style={{
//             transform: `scale(${zoomLevel}) rotate(${
//               isMobile ? "-90deg" : "0deg"
//             })`,
//             transition: "transform 0.3s ease",
//           }}
//           draggable={false}
//         />
//       </div>

//       {isMobile && (
//         <Floors
//           variant="tour"
//           onFloorSelect={(floor) => setCurrentFloor(floor)}
//         />
//       )}

//       <ExplourZoom
//         onZoomIn={handleZoomIn}
//         onZoomOut={handleZoomOut}
//         onRestart={handleRestart}
//       />
//     </div>
//   );
// }

// export default Tour;
